/**
 * variant-card.js
 * ============================================================
 * Keeps .selected class in sync when Shopify's theme JS
 * changes the checked radio (e.g. via URL params on page load,
 * or when another option changes and re-evaluates availability).
 *
 * Include once in your bundle or via:
 *   <script src="{{ 'variant-card.js' | asset_url }}" defer></script>
 * ============================================================
 */
(function () {
  'use strict';

  function syncCards(container) {
    container.querySelectorAll('.m-variant-card').forEach(function (card) {
      var radio = card.querySelector('input[type="radio"]');
      if (!radio) return;
      card.classList.toggle('selected', radio.checked);
    });
  }

  function initContainer(container) {
    /* Click on the card div itself (outside the label) */
    container.querySelectorAll('.m-variant-card').forEach(function (card) {
      card.addEventListener('click', function () {
        var radio = card.querySelector('input[type="radio"]');
        if (!radio || radio.disabled) return;
        radio.checked = true;
        radio.dispatchEvent(new Event('change', { bubbles: true }));
        syncCards(container);
      });
    });

    /* Keyboard support (Enter / Space) */
    container.querySelectorAll('.m-variant-card').forEach(function (card) {
      card.setAttribute('tabindex', '0');
      card.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          card.click();
        }
      });
    });

    /* React to external radio changes (theme JS, URL-param selection) */
    container.querySelectorAll('.m-variant-card input[type="radio"]').forEach(function (radio) {
      radio.addEventListener('change', function () {
        syncCards(container);
      });
    });

    /* Initial sync */
    syncCards(container);
  }

  function init() {
    document.querySelectorAll('.m-product-option__values:has(.m-variant-card)').forEach(initContainer);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  /* Shopify Section Rendering API — re-init after Ajax section swap */
  document.addEventListener('shopify:section:load', init);
})();